// A list page's last filters/page (purchase orders, shipments), so leaving
// a record (back, cancel or save) returns to the same view rather than page
// one. Kept per browser tab; storage can be unavailable (private mode), so
// it's best-effort.
const KEY = 'purchases.listQuery';
export const SHIPMENTS_LIST_KEY = 'shipments.listQuery';

export function saveListQuery(params: Record<string, string | number | null>, key = KEY): void {
  try {
    const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== ''));
    sessionStorage.setItem(key, JSON.stringify(clean));
  } catch {
    // Not critical - the list just opens on its defaults.
  }
}

export function lastListQuery(key = KEY): Record<string, string> {
  try {
    return JSON.parse(sessionStorage.getItem(key) || '{}');
  } catch {
    return {};
  }
}
